import type { ReactNode } from "react";
import { cn } from "@/lib/utils";
import "./FilterHeader.scss";

type FilterHeaderProps = {
  children?: ReactNode;
  end?: ReactNode;
  className?: string;
};

function FilterHeader({
  children,
  end = null,
  className,
}: FilterHeaderProps) {
  const hasEnd = Boolean(end);

  return (
    <div
      className={cn(
        "filter-header",
        hasEnd && "filter-header--has-end",
        className
      )}
    >
      <div className="filter-header__start">{children}</div>
      {hasEnd ? <div className="filter-header__end">{end}</div> : null}
    </div>
  );
}

export default FilterHeader;
